import { TextField } from '@mui/material';
import { useSyncedInputValue } from './useSyncedInputValue';

interface DateEditorProps {
    value: string;
    onChange: (value: string) => void;
}

function DateEditor({ value, onChange }: DateEditorProps) {
    const inputRef = useSyncedInputValue(value || '');

    return (
        <TextField
            inputRef={inputRef}
            type="date"
            size="small"
            fullWidth
            defaultValue={value || ''}
            onBlur={(e) => onChange(e.target.value)}
            InputLabelProps={{
                shrink: true,
            }}
        />
    );
}

export default DateEditor;
